import { useContext } from 'react';
import { authContext } from '../utils/ProvideAuth';

export default function useAuth() {
    return useContext(authContext);
}
